<div class="dealer-deal-card" [routerLink]="redirect">
    <div class="left-side">
        <div class="deal-image-container">
            <img [src]="vehicleImage" (error)="showMissingImage($event)" alt="image of vehicle you've purchased" />
        </div>
    </div>

    <div class="right-side">
        <!-- buyer info -->
        <div [ngClass]="deal.coBuyer?.firstName ? 'cobuyer-spacing' : 'buyer-spacing'">
            <div class="check-title-wrap">
                <h1>{{ deal.buyer.firstName }} {{ deal.buyer.lastName }}</h1>
            </div>
            <ng-container *ngIf="deal.coBuyer?.firstName">
                <p>Co-Buyer: {{ deal.coBuyer.firstName }} {{ deal.coBuyer.lastName }}</p>
            </ng-container>
            <ng-container *ngIf="deal.dealerDealNumber">
                <p>
                    Deal #: <b>{{ deal.dealerDealNumber }}</b>
                </p>
            </ng-container>
            <p>Jacket ID: {{ deal.dealId }}</p>
            <p>Created By: {{ deal.createdByUser.firstName }} {{ deal.createdByUser.lastName }}</p>
            <p>Finance Manager: N/A</p>
        </div>

        <!-- vehicle info -->
        <div class="vehicle-info">
            <p>
                <b>
                    <span *ngIf="deal.vehicle?.year > 0">{{ deal.vehicle?.year }}</span>
                    {{ deal.vehicle?.make }} {{ deal.vehicle?.model }}
                </b>
            </p>
            <p>
                VIN: <b>{{ deal.vehicle?.vin }}</b>
            </p>
            <p>Stock ID: {{ deal.vehicle?.stockNumber }}</p>
        </div>
    </div>
    <div class="rightermost-content">
        <p *ngIf="!isCategoryType([DealStatuses.Open])" class="jacket-category">
            {{ displayCategory(deal.statusId) }}
        </p>
        <div *ngIf="isCategoryType([DealStatuses.Open]) && getLastDocumentUpdateDate()">
            <p class="last-update">
                <mat-icon>access_time</mat-icon>
                {{ documentLastUpdatedDays }}
            </p>
        </div>
    </div>
</div>
